<template>
  <section>
    <div v-if="!isLoaded" class="h-screen vld-parent">
      <loading :active="!isLoaded" :is-full-page="false" />
    </div>

    <div class="max-w-6xl mx-auto mt-3 lg:mt-10 md:mt-5" v-if="isLoaded">
      <!-- title -->
      <div>
        <div class="font-bold text-22px text-oCharcoal">
          <i class="fas fa-bell text-22px text-oOrange"></i>
          <span class="pl-3">{{
            $t(
              'components.settingsManagement.events.headline.eventNotification.title'
            )
          }}</span>
        </div>
        <p class="break-words title-description mt-1">
          {{
            $t(
              'components.settingsManagement.events.headline.eventNotification.description'
            )
          }}
        </p>
      </div>

      <div class="mt-3 pt-5 border-t-2">
        <div class="grid grid-cols-1 gap-4  md:grid-cols-2 lg:grid-cols-3">
          <template v-for="(item, index) in events">
            <div :key="index" class="mb-5">
              <input-label class="mb-1" :text="item.title" />
              <t-checkbox
                wrapped
                :label="
                  $t(
                    'components.settingsManagement.events.eventNotification.email'
                  )
                "
                :name="`EmailEnabled_${item.id}`"
                v-model="item.email_enabled"
                @change="onOff(index, item, 'email', $event)"
              />
              <template>
                <t-checkbox
                  wrapped
                  :label="
                    $t(
                      'components.settingsManagement.events.eventNotification.slack'
                    )
                  "
                  :name="`SlackEnabled_${item.id}`"
                  v-model="item.slack_enabled"
                  @change="onOff(index, item, 'slack', $event)"
                />
                <p
                  v-if="item.slack_channel_name"
                  class="text-oGray text-xs pl-7 -mt-2"
                >
                  #{{ item.slack_channel_name }}
                </p>
              </template>

              <t-checkbox
                wrapped
                :label="
                  $t(
                    'components.settingsManagement.events.eventNotification.webNotification'
                  )
                "
                :name="`WebNotiEnabled_${item.id}`"
                v-model="item.web_noti_enabled"
                @change="onOff(index, item, 'web', $event)"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <t-modal
      name="slack-channel"
      :variant="`lg`"
      :hideCloseButton="true"
      :disableBodyScroll="true"
    >
      <header class="py-4 px-3 mt-5">
        <div class="flex justify-between modal-header">
          <div class="w-full text-left">
            <div class="px-4 text-xl font-extrabold text-center">
              {{ getEvent ? `${getEvent.title} -` : '' }} Channel Name
            </div>
          </div>
        </div>
      </header>

      <section class="w-full h-28 px-4">
        <AppInput
          class="justify-center"
          v-model="slackChannelName"
          type="text"
          name=""
          label=""
          placeholder="e.g. general-notifications"
          :haveSuggestion="true"
          :suggestionNonAlertClass="`text-gray-700 mt-2`"
          :suggestionText="
            $t(
              'components.settingsManagement.events.eventNotification.slackChannelPopUp.description'
            )
          "
        />
      </section>

      <div class="flex gap-4 justify-end py-2 px-4 bg-white modal-header">
        <AppButton
          :text="$t('components.stepNavigation.cancel')"
          :variant="'secondary'"
          @click="handleCancel()"
        />
        <AppButton
          :text="$t('components.stepNavigation.save')"
          :variant="'primary'"
          @click="handleSlackChannelSubmit()"
        />
      </div>
    </t-modal>
  </section>
</template>

<script>
import InputLabel from '@/components/form/InputLabel'
import { EventSettingsConfig } from '@/config/SettingsConfig'

export default {
  name: 'EventSettings',
  components: {
    InputLabel,
  },
  data() {
    return {
      isLoaded: false,
      events: [],
      // one
      illegal_move: [],
      idle_vehicle: [],
      low_speed_zone: [],
      fallen_down: [],
      // two
      critical_battery: [],
      restricted_area: [],
      iot_removed: [],
      negative_balance: [],
      // three
      pull_up: [],
      aa: null,
      slackChannelName: '#',
      eventIndex: null,
    }
  },
  computed: {
    orgId() {
      return this.$store.getters['auth/organizationInfo'].id || null
    },

    getEvent() {
      return this.eventIndex !== null ? this.events[this.eventIndex] : null
    },
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      this.$http
        .get(EventSettingsConfig.api.index(this.orgId))
        .then((res) => {
          console.log('settings', res.data)

          this.events = res.data.data
          console.log('settingsEv', this.events)
          this.isLoaded = true
        })
        .catch((err) => {
          console.log('settignsErr', err)
        })
    },
    async onOff(index = null, item, key, val) {
      // console.log(item, key, val);
      let data, toastTitle, toastText, toastTextNegative, makeToastText

      data = new FormData()

      makeToastText = (channel, positive = true) => {
        let negative = '',
          onOffText = ''

        if (positive) {
          onOffText = val === true ? 'enabled' : 'disabled'
        } else {
          onOffText = val === true ? 'enable' : 'disable'
          negative = 'Failed to update '
        }

        return `${negative} ${channel} notification ${onOffText} for ${item.title} event`
      }

      toastTitle = `${item.title} Notification`

      if (key === 'email') {
        toastText = makeToastText('Email')
        toastTextNegative = makeToastText('Email', false)
        data.append('email_enabled', val)
      }

      if (key === 'slack') {
        toastText = makeToastText('Slack')
        toastTextNegative = makeToastText('Slack', false)
        if (val) {
          this.eventIndex = index
          this.slackChannelName = `#${item.slack_channel_name ?? ''}` || ''
          this.$modal.show('slack-channel')
          return
        } else {
          data.append('slack_enabled', val)
        }
      }

      if (key === 'web') {
        toastText = makeToastText('Web')
        toastTextNegative = makeToastText('Web', false)
        data.append('web_noti_enabled', val)
      }

      await this.$http
        .patch(EventSettingsConfig.api.update(item.id), data)
        .then((res) => {
          console.log(res)
          this.$notify(
            {
              group: 'generic',
              type: 'success',
              title: toastTitle,
              text: toastText,
            },
            3000
          )
          return true
        })
        .catch((err) => {
          // todo: reverse toggle state
          console.log('onOffE', err)
          this.$notify(
            {
              group: 'generic',
              type: 'error',
              title: toastTitle,
              text: toastTextNegative,
            },
            3000
          )
        })
    },
    async handleCancel() {
      this.$modal.hide('slack-channel')
      this.slackChannelName = ''
      await this.fetchData()
    },
    async handleSlackChannelSubmit() {
      if (
        this.slackChannelName.trim().replace('#', '') &&
        this.events[this.eventIndex].slack_enabled
      ) {
        const data = new FormData()
        data.append(
          'slack_channel_name',
          this.slackChannelName.trim().replace('#', '')
        )
        data.append('slack_enabled', this.events[this.eventIndex].slack_enabled)

        await this.$http
          .patch(
            EventSettingsConfig.api.update(this.events[this.eventIndex].id),
            data
          )
          .then((res) => {
            console.log(res)
            this.$notify(
              {
                group: 'generic',
                type: 'success',
                title: 'Success',
                text: 'Updated  successfully',
              },
              3000
            )
            return true
          })
          .catch((err) => {
            // todo: reverse toggle state
            console.log('onOffE', err)
            this.$notify(
              {
                group: 'generic',
                type: 'error',
                title: 'Failed',
                text: 'Failed to update',
              },
              3000
            )
          })
          .finally(() => {
            this.$modal.hide('slack-channel')
            this.slackChannelName = ''
            this.fetchData()
          })
      } else {
        this.$notify(
          {
            group: 'generic',
            type: 'error',
            title: 'Error',
            text: 'Please enter a valid channel name',
          },
          3000
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title-description {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #63636c !important;
}
</style>
